import { render, staticRenderFns } from "./AdminCorporate.vue?vue&type=template&id=7de899c3&scoped=true"
import script from "./AdminCorporate.vue?vue&type=script&lang=js"
export * from "./AdminCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de899c3",
  null
  
)

export default component.exports